var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-pagination',{attrs:{"outlined":"","color":_vm.$theme.primary,"total-visible":"7","length":_vm.get_lojas.totalPages},on:{"input":function($event){return _vm.setPage($event)}},model:{value:(_vm.get_lojas_filtros.page),callback:function ($$v) {_vm.$set(_vm.get_lojas_filtros, "page", $$v)},expression:"get_lojas_filtros.page"}})
}
var staticRenderFns = []

export { render, staticRenderFns }